module.exports = __webpack_public_path__ + "img/Case.7fd8ae26.png";